export default __webpack_public_path__ + "assets/card-logo-elo-component.0c3fd5a0.svg";